// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class CustodialData {
    constructor() {
        this.InstrumentGroupId = null;
        this.InstrumentId = '';
        this.Fee = 0;
        this.Measure = 0;
    }
    // this.FormattedValue = ""
    FormattedValue() {
        return this.Fee + ' ' + CustodialMeasure.descriotionMap[this.Measure];
    }
}
export class CustodialMeasure {
}
CustodialMeasure.descriotionMap = { 0: 'bp' };
